export default __webpack_public_path__ + "static/media/section1.53370bc1.png";